import { useCallback, useMemo, useState } from 'react';

export const useFewerOptionsWhileCollapsed = <T>({
  options,
  collapsedCount,
}: {
  options: Array<T>;
  collapsedCount: number;
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const toggleCollapse = useCallback(() => setIsCollapsed((is) => !is), []);

  const { collapsedOptions, expandedOptions } = useMemo(
    () => ({
      collapsedOptions: options.slice(0, collapsedCount),
      expandedOptions: options.slice(collapsedCount, options.length),
    }),
    [collapsedCount, options]
  );

  return {
    isCollapsed,
    setIsCollapsed,
    toggleCollapse,
    canExpand: options.length > collapsedCount,
    collapsedOptions,
    expandedOptions,
  };
};
